module.exports = __webpack_public_path__ + "static/media/wedding05.2edf7e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding05.jpg
// module id = 425
// module chunks = 0